import RequestsList from "@/components/Requests/RequestsList.vue";
import RequestsHeader from "@/components/Requests/RequestsHeader.vue";
import RequestEdit from "@/components/Requests/RequestEdit.vue";

export default [
    {
        path: "/requests",
        alias: ["/request"],
        name: "Requests",
        redirect: "/request/list",
        components: {
            page: RequestsList,
            header: RequestsHeader
        },
        meta: {
            title: "Requests",
            requiresAuth: true
        },
        children: [
            {
                path: "/request/list",
                name: "Request List",
                components: {
                    // Empty - uses parent page component
                }
            },
            {
                path: "/request/edit/:id",
                name: "Request Edit",
                components: {
                    modal: RequestEdit
                }
            }
        ]
    }
];
